import React from "react";

const CheckBox = ({ name, onChange, checked, defaultChecked }) => {
  return (
    <label className="flex gap-2 justify-start items-center">
      <input
        defaultChecked={defaultChecked}
        checked={checked}
        type="checkbox"
        onChange={onChange}
        value={name}
      />
      <div>
        <p className="text-[16px]">{name}</p>
      </div>
    </label>
  );
};

export default CheckBox;
